import React from 'react';
import { LocateOffIcon } from 'lucide-react';
import { StatusBar } from '../phone/StatusBar';
import { QrCode } from '../QrCode';
const BG = 'https://cdn.magicpatterns.com/patterns/generated-images/516ef107-4d6b-4e20-b94e-27c564b09b2f.jpg';
export function CheckInScreen() {
  return <div className="relative h-full bg-ink text-white" data-id="element-233" data-mp="2af8ghh7h3ugb">
      <img src={BG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-50" data-id="element-234" data-mp="2agt931a893bj" />
      <div className="absolute inset-0 bg-forest-deep/60" data-id="element-235" data-mp="2egtz7j6ov2yf" />
      <div className="relative z-10 flex h-full flex-col" data-id="element-236" data-mp="2jfdjzg9jq8p7">
        <StatusBar tone="light" data-id="element-237" data-mp="2jhzspj86au90" />
        <div className="px-5 pt-6 text-center" data-id="element-238" data-mp="2oezxzrx77sz2">
          <p className="text-[10px] text-white/65" data-id="element-239" data-mp="2od6q69aun2ph">Summer Festival · Amsterdam</p>
          <p className="font-display text-[20px] font-extrabold tracking-tight" data-id="element-240" data-mp="2tdugesr97fin">Check in</p>
        </div>

        <div className="relative mx-auto mt-10 h-[180px] w-[180px]" data-id="element-241" data-mp="u331vlnt9yxo">
          <span className="absolute left-0 top-0 h-8 w-8 rounded-tl-2xl border-l-[3px] border-t-[3px] border-mint" data-id="element-242" data-mp="z1cz01t3j9lx" />
          <span className="absolute right-0 top-0 h-8 w-8 rounded-tr-2xl border-r-[3px] border-t-[3px] border-mint" data-id="element-243" data-mp="23sb201apx3tb" />
          <span className="absolute bottom-0 left-0 h-8 w-8 rounded-bl-2xl border-b-[3px] border-l-[3px] border-mint" data-id="element-244" data-mp="1yyovkqv5dw5y" />
          <span className="absolute bottom-0 right-0 h-8 w-8 rounded-br-2xl border-b-[3px] border-r-[3px] border-mint" data-id="element-245" data-mp="1p1u1ql9tkjy0" />
          <div className="absolute inset-8 opacity-90" data-id="element-246" data-mp="2mq46h80zplst">
            <QrCode size={116} color="#FFFFFF" data-id="element-247" data-mp="2mnhyx8e3n6al" />
          </div>
          <span className="animate-scan absolute inset-x-3 h-0.5 rounded-full bg-mint shadow-[0_0_12px_2px_rgba(142,235,193,0.6)]" data-id="element-248" data-mp="2hrj698lqn24d" />
        </div>

        <div className="m-4 mt-auto rounded-2xl bg-white p-4 text-ink" data-id="element-249" data-mp="2ct97yp4pvlej">
          <p className="text-[12px] font-bold" data-id="element-250" data-mp="28p9sm9v6asmr">Point at the AVEGA code</p>
          <p className="mt-1 text-[10px] leading-snug text-muted" data-id="element-251" data-mp="11daso3iy434v">
            Find it at the venue to confirm you're here and unlock this event's actions.
          </p>
          <p className="mt-3 flex items-center gap-1.5 text-[10px] font-semibold text-forest" data-id="element-252" data-mp="ys32cv7v83ra">
            <LocateOffIcon className="h-3 w-3" data-id="element-253" data-mp="13qmpgyy73ll8" />
            No continuous location tracking
          </p>
        </div>
      </div>
    </div>;
}